import {
  TemplateVariableEditModalProps,
  VariableItem
} from '@/template/interface'
import { getFormatMessage } from '@/utils/utils'
import { Modal } from 'antd'
import React, { useState } from 'react'
import { TemplateVariableEdit } from '.'

export const TemplateVariableEditModal: React.FC<TemplateVariableEditModalProps> =
  (props: TemplateVariableEditModalProps) => {
    const {
      visible,
      editItem,
      batch,
      plcs,
      onVisibleChange,
      onFormSubmit,
      onFormValidate
    } = props
    const [formResult, setFormResult] = useState<boolean>(false)
    const formatMessage = getFormatMessage()
    const title = batch
      ? formatMessage({ id: 'app.template.variable.edit.title.batch' })
      : editItem?.id
      ? formatMessage({
          id: 'app.template.variable.edit.title',
          parameters: { name: editItem.name }
        })
      : formatMessage({ id: 'app.template.variable.toolbar.create' })

    const handleFormValidate = (ok: boolean, item?: VariableItem): boolean => {
      setFormResult(false)
      if (onFormValidate) {
        return onFormValidate(ok, item)
      }
      return true
    }

    const handleSubmit = (item: VariableItem) => {
      setFormResult(false)
      onVisibleChange?.(false)
      onFormSubmit?.(item)
    }

    return (
      <Modal
        visible={visible}
        onCancel={() => onVisibleChange?.(false)}
        title={title}
        width={650}
        onOk={() => setFormResult(true)}
        okText={formatMessage({ id: 'app.modal.ok' })}
        cancelText={formatMessage({ id: 'app.modal.cancel' })}
        maskClosable={false}
        destroyOnClose={true}
      >
        <TemplateVariableEdit
          references={props.references}
          batch={batch}
          item={editItem}
          formResult={formResult}
          plcs={plcs}
          onFormValidate={handleFormValidate}
          onFormSubmit={handleSubmit}
          onRefRelease={props.onRefRelease}
        />
      </Modal>
    )
  }
